// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.editorView {
  width: 100%;
  height: 100vh !important;
}`, "",{"version":3,"sources":["webpack://./src/app/common/online-editor/online-editor.component.scss"],"names":[],"mappings":"AAAA;EACC,WAAA;EACA,wBAAA;AACD","sourcesContent":[".editorView {\r\n\twidth: 100%;\r\n\theight: 100vh !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
